// YMQ PDF Generator con template de marca y metafield cuadro_silla
function generateYMQPDF() {
  const productName = document.querySelector('.product__title, h1')?.textContent.trim() || 'Producto';
  const cuadroSilla = document.getElementById('product-metafields')?.getAttribute('data-cuadro-silla') || '';


  const camposObligatoriosSinSeleccion = [];
  document.querySelectorAll('[class*="ymq-options-box"]').forEach(container => {
    const esVisible = window.getComputedStyle(container).display !== 'none';
    if (!esVisible) return;

    const label = container.querySelector('[class*="ymq_lable"]');
    const esObligatorio = label?.classList.contains('ymq-option-required');
    if (!esObligatorio) return;

    const titulo = label?.textContent.trim() || '';
    let tieneSeleccion = false;

    container.querySelectorAll('input[type="radio"]').forEach(input => {
      if (input.checked) tieneSeleccion = true;
    });
    container.querySelectorAll('input[type="checkbox"]').forEach(input => {
      if (input.checked) tieneSeleccion = true;
    });
    container.querySelectorAll('input[class*="ymq-option-swatches-input"]').forEach(input => {
      if (input.checked) tieneSeleccion = true;
    });

    if (!tieneSeleccion) {
      camposObligatoriosSinSeleccion.push(titulo);
    }
  });

  if (camposObligatoriosSinSeleccion.length > 0) {
    alert('Por favor, completá todos los campos obligatorios antes de descargar la prescripción.');
    return;
  }

  const selections = [];
  document.querySelectorAll('[class*="ymq-options-box"]').forEach(container => {
    const esVisible = window.getComputedStyle(container).display !== 'none';
    if (!esVisible) return;

    const titulo = container.querySelector('[class*="ymq_lable"]')?.textContent.trim() || '';
    if (!titulo) return;

    // Caso 1: Radio buttons
    const todosRadios = container.querySelectorAll('input[type="radio"][class*="ymq-option-rc-input"]');
    if (todosRadios.length > 0) {
      let radioSeleccionado = null;
      todosRadios.forEach(input => {
        if (input.checked) radioSeleccionado = input;
      });
      if (radioSeleccionado) {
        const sku = radioSeleccionado.getAttribute('ymq-option-sku') || '';
        if (sku.trim()) selections.push({ sku: sku });
      }
      return;
    }

    // Caso 2: Checkboxes
    const todosCheckboxes = container.querySelectorAll('input[type="checkbox"][class*="ymq-option-rc-input"]');
    if (todosCheckboxes.length > 0) {
      todosCheckboxes.forEach(input => {
        if (input.checked) {
          const sku = input.getAttribute('ymq-option-sku') || '';
          if (sku.trim()) selections.push({ sku: sku });
        }
      });
      return;
    }

    // Caso 3: Swatches originales
    let inputSeleccionado = null;
    container.querySelectorAll('input[class*="ymq-option-swatches-input"]').forEach(input => {
      if (input.checked) inputSeleccionado = input;
    });
    if (inputSeleccionado) {
      const sku = inputSeleccionado.getAttribute('ymq-option-sku') || '';
      if (sku.trim()) selections.push({ sku: sku });
    }
  });

  if (selections.length === 0) {
    alert('Por favor, selecciona al menos una opción antes de generar el PDF.');
    return;
  }

  const { jsPDF } = window.jspdf;
  const doc = new jsPDF();
  const templateUrl = 'https://cdn.shopify.com/s/files/1/0710/3994/2811/files/Prescripcion_pdf_4__page-0001.jpg?v=1773925269';

  const templateImg = new Image();
  templateImg.crossOrigin = 'Anonymous';

  function generarPDF(templateImg) {
    const marginX = 20;
    const marginRight = 183;
    const maxWidth = marginRight - marginX;
    const contentStartY = 40;
    const contentEndY = 250;

    // lineHeight por fontSize: fontSize * 0.4 da el interlineado proporcional en jsPDF
    const lineHeightBody = 9 * 0.45;   // ≈ 4.05 — para fontSize 9
    const gapEntreItems = 2;           // espacio fijo y uniforme entre cada SKU

    function limpiarTexto(texto) {
      return texto
        .replace(/\s+/g, ' ')
        .trim()
        .replace(/(\S{20})/g, '$1 ');
    }

    function nuevaPagina() {
      doc.addPage();
      doc.addImage(templateImg, 'JPEG', 0, 0, 210, 297);
      return contentStartY;
    }

    function checkPageBreak(y, espacioNecesario) {
      if (y + espacioNecesario > contentEndY) {
        return nuevaPagina();
      }
      return y;
    }

    doc.addImage(templateImg, 'JPEG', 0, 0, 210, 297);

    // ── Título del producto ──────────────────────────────────────
    // CAMBIO: fontSize 14 → 48
    const fontSizeTitulo = 32;
    const lineHeightTitulo = fontSizeTitulo * 0.45; // ≈ 21.6
    doc.setFontSize(fontSizeTitulo);
    doc.setTextColor(41, 72, 152);
    doc.setFont(undefined, 'bold');
    const nombreLines = doc.splitTextToSize(limpiarTexto(productName), maxWidth);
    doc.text(nombreLines, marginX, 55);
    let yPosition = 55 + (nombreLines.length * lineHeightTitulo) + 0;

    // ── Metafield cuadro_silla ───────────────────────────────────
    // CAMBIO: fontSize 8 → 9
    if (cuadroSilla) {
      doc.setFontSize(9);
      doc.setTextColor(50, 50, 50);
      doc.setFont(undefined, 'normal');
      const cuadroLimpio = limpiarTexto(cuadroSilla);
      const cuadroLines = doc.splitTextToSize(cuadroLimpio, maxWidth);
      yPosition = checkPageBreak(yPosition, cuadroLines.length * lineHeightBody + 3);
      doc.text(cuadroLines, marginX, yPosition);
      yPosition += (cuadroLines.length * lineHeightBody) + 2;
    }

    doc.setTextColor(0, 0, 0);

    // ── SKUs ─────────────────────────────────────────────────────
    // CAMBIO: fontSize 8 → 9, espaciado uniforme con gapEntreItems fijo
    selections.forEach((sel) => {
      if (!sel.sku.trim()) return;
      doc.setFontSize(9);
      doc.setFont(undefined, 'normal');
      doc.setTextColor(30, 30, 30);
      const skuLines = doc.splitTextToSize(limpiarTexto(sel.sku), maxWidth);
      const espacioTotal = (skuLines.length * lineHeightBody) + gapEntreItems;
      yPosition = checkPageBreak(yPosition, espacioTotal);
      doc.text(skuLines, marginX, yPosition);
      // CAMBIO: espaciado post-item siempre igual = lineHeightBody * líneas + gapEntreItems fijo
      yPosition += (skuLines.length * lineHeightBody) + gapEntreItems;
    });

    const fileName = `${productName.replace(/[^a-z0-9]/gi, '_')}_prescripcion.pdf`;
    doc.save(fileName);
  }

  templateImg.onload = function() {
    generarPDF(templateImg);
  };

  templateImg.onerror = function() {
    alert('No se pudo cargar el template.');
  };

  templateImg.src = templateUrl;
}

// Agregar el botón cuando la página cargue
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    const ymqOption = document.querySelector('ymq-option');

    if (ymqOption) {
      if (document.querySelector('.ymq-pdf-button')) {
        console.log('El botón ya existe');
        return;
      }

      const estilosResponsive = document.createElement('style');
      estilosResponsive.textContent = `
        .ymq-pdf-container {
          text-align: left;
        }
        .ymq-pdf-button {
          width: auto !important;
          max-width: 400px;
        }
        @media (max-width: 749px) {
          .ymq-pdf-container {
            text-align: center;
          }
          .ymq-pdf-button {
            width: 100% !important;
          }
        }
      `;
      document.head.appendChild(estilosResponsive);

      const buttonContainer = document.createElement('div');
      buttonContainer.style.marginTop = '20px';
      buttonContainer.style.marginBottom = '20px';
      buttonContainer.className = 'ymq-pdf-container';

      const pdfButton = document.createElement('button');
      pdfButton.type = 'button';
      pdfButton.className = 'button ymq-pdf-button';
      pdfButton.textContent = 'Descargar Sugerencia Médica';

      pdfButton.addEventListener('click', generateYMQPDF);
      buttonContainer.appendChild(pdfButton);

      ymqOption.parentNode.insertBefore(buttonContainer, ymqOption.nextSibling);
      console.log('Boton agregado despues de todas las opciones YMQ');
    } else {
      console.log('No se encontro el contenedor ymq-option');
    }
  }, 3000);
});




